export const setSelectedSiteStartDay = (startDay) => localStorage.setItem('selected-site-start-day', startDay);

export const getSelectedSiteStartDay = () => localStorage.getItem('selected-site-start-day');
